var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfessionals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 121,
    height: 121.001,
    viewBox: "0 0 121 121.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111897",
    "data-name": "Path 111897",
    d: "M60,0A60,60,0,1,1,0,60,60,60,0,0,1,60,0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19860",
    "data-name": "Rectangle 19860",
    width: 183.673,
    height: 364.776,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_80547",
    "data-name": "Group 80547",
    transform: "translate(-2610.934 -478.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_31",
    "data-name": "Mask Group 31",
    transform: "translate(2611.434 479.434)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80546",
    "data-name": "Group 80546",
    transform: "translate(-67.164 14.593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80543",
    "data-name": "Group 80543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80542",
    "data-name": "Group 80542",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111780",
    "data-name": "Path 111780",
    d: "M41.731,114.455a39.649,39.649,0,0,1-4.946-1.515c-1.319-.629-4.819-4.93-5.6-5.277s.013,1.732.569,2.78,2.281,3.866,3.315,4.574a28.2,28.2,0,0,0,6.421,3.171Z",
    transform: "translate(-0.468 -1.631)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111781",
    "data-name": "Path 111781",
    d: "M39.627,114.919a40.618,40.618,0,0,1-4-1.916c-1.319-.8-4.74-6.49-4.381-5.491a29.181,29.181,0,0,0,3.795,5.812,20.826,20.826,0,0,0,4.276,2.042Z",
    transform: "translate(-0.473 -1.627)",
    fill: "#e6b296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111782",
    "data-name": "Path 111782",
    d: "M41.173,113.107a51.444,51.444,0,0,1-5.157-2.282c-1.32-.8-4.39-6.214-5.177-6.666s-.422,1.471-.062,2.472,3.647,6.32,4.711,6.866,6.726,3.179,6.726,3.179Z",
    transform: "translate(-0.46 -1.577)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111783",
    "data-name": "Path 111783",
    d: "M39.616,110.687a10.1,10.1,0,0,1-4.151-.763c-1.451-.824-5.194-6.829-4.876-5.685s3.227,6.536,4.4,7.161a27.6,27.6,0,0,0,3.824,1.452Z",
    transform: "translate(-0.463 -1.577)",
    fill: "#e6b296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111784",
    "data-name": "Path 111784",
    d: "M41.828,110.3a49.872,49.872,0,0,1-5.756-2.23c-1.451-.824-4.477-6.921-5.346-7.383s-.634,1.768-.316,2.913,3.6,7.11,4.784,7.658,7.487,3.147,7.487,3.147Z",
    transform: "translate(-0.456 -1.525)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111785",
    "data-name": "Path 111785",
    d: "M41.132,108.7s-3.9-2.784-5.346-3.608-3.7-5.616-4.567-6.078-1.057.755-.737,1.9,3.245,6.817,4.426,7.366,4.222,1.536,4.222,1.536Z",
    transform: "translate(-0.46 -1.499)",
    fill: "#e6b296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111786",
    "data-name": "Path 111786",
    d: "M43.276,108.912s-5.865-3.2-7.315-4.027-4.477-6.921-5.346-7.383-.635,1.768-.317,2.912,3.6,7.111,4.785,7.659,7.487,3.147,7.487,3.147Z",
    transform: "translate(-0.455 -1.476)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111787",
    "data-name": "Path 111787",
    d: "M45.882,107.493s1.775,2.849,2.32,4.054,3.557,1.959,4.211,2.94.248,6.263-.567,6.352-4.9-2.646-5.757-2.739c-1.468-.158-2.242,1-4.758-.029-1.747-.713-.672-8.488.687-8.549s3.864-2.029,3.864-2.029",
    transform: "translate(-0.612 -1.629)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111788",
    "data-name": "Path 111788",
    d: "M14.513,131.6s21.252,1.43,25.011-.631l-4.5-4.061Z",
    transform: "translate(-0.22 -1.923)",
    fill: "#d4d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111789",
    "data-name": "Path 111789",
    d: "M12.932,130.691,0,129.427,5.444,73.746,45,77.613s-3.795,38.814-5.047,51.63c0,0-.59,3.462-5.465-2.332,0,0-11.231,4.79-21.555,3.781",
    transform: "translate(0 -1.117)",
    fill: "#e5e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111790",
    "data-name": "Path 111790",
    d: "M35.541,91.258l-23.985-2.2a.942.942,0,0,1,.172-1.875l23.985,2.2a.942.942,0,1,1-.172,1.875",
    transform: "translate(-0.162 -1.321)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111791",
    "data-name": "Path 111791",
    d: "M34.778,98.122l-23.985-2.2a.941.941,0,1,1,.171-1.875l23.985,2.2a.941.941,0,1,1-.171,1.875",
    transform: "translate(-0.151 -1.425)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111792",
    "data-name": "Path 111792",
    d: "M34.093,104.985l-23.984-2.2a.941.941,0,1,1,.171-1.875l23.985,2.2a.942.942,0,1,1-.172,1.875",
    transform: "translate(-0.14 -1.529)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111793",
    "data-name": "Path 111793",
    d: "M33.444,111.848l-23.984-2.2a.941.941,0,1,1,.171-1.875l23.985,2.2a.942.942,0,1,1-.172,1.875",
    transform: "translate(-0.13 -1.633)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111794",
    "data-name": "Path 111794",
    d: "M45.856,107.392a14.706,14.706,0,0,0-2.818-3.492c-1.485-1.179-2.4-4.066-3.821-2.747s.558,4.276,1.908,5.559a4.073,4.073,0,0,1,1.512,3.122c-.135.358,2.054,2.44,2.676.869a9.124,9.124,0,0,0,.544-3.31",
    transform: "translate(-0.587 -1.528)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111795",
    "data-name": "Path 111795",
    d: "M129.935,14.155s-18.944,4.253-22.562,23-4.317,18.827-3.11,25.067,7.046,16.418,18.536,13c0,0,7.01-2.682,1.727-7.781Z",
    transform: "translate(-1.571 -0.214)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111796",
    "data-name": "Path 111796",
    d: "M128.16,14.155s18.944,4.345,22.562,23.5,4.317,19.236,3.11,25.612S146.786,80.04,135.3,76.547c0,0-7.01-2.74-1.727-7.951Z",
    transform: "translate(-1.942 -0.214)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111797",
    "data-name": "Path 111797",
    d: "M159.34,77.79s1.508-3.584-9.378-4.514-10.3-1.328-12.685-3.717-1.233-13.884-1.233-13.884H123.721s1.156,11.5-1.233,13.884-1.8,2.788-12.686,3.717-9.377,4.514-9.377,4.514c-1.726,4.911,9.059,16.131,15.3,16.131h28.319c6.239,0,17.023-11.219,15.3-16.131",
    transform: "translate(-1.519 -0.844)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111798",
    "data-name": "Path 111798",
    d: "M136.136,62.682a64.763,64.763,0,0,1,.266-7.008H124.078s.732,7.264-.169,11.444c0,0,5.365,1.109,7.786,0s4.441-4.436,4.441-4.436",
    transform: "translate(-1.877 -0.844)",
    fill: "#e6a987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111799",
    "data-name": "Path 111799",
    d: "M113.154,35.158s-2.37-2.506-4.176-.129-1.382,5.246.85,8.009,3.506,3.293,5.524.637Z",
    transform: "translate(-1.634 -0.515)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111800",
    "data-name": "Path 111800",
    d: "M111.628,35.729a2.58,2.58,0,0,0-2.032,3.066,9.608,9.608,0,0,0,2.032,4.946s-1.809-2.975-1.745-5.122a3.252,3.252,0,0,1,1.745-2.89",
    transform: "translate(-1.66 -0.541)",
    fill: "#db9f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111801",
    "data-name": "Path 111801",
    d: "M146.465,35.158s2.369-2.506,4.175-.129,1.382,5.246-.849,8.009-3.507,3.293-5.525.637Z",
    transform: "translate(-2.186 -0.515)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111802",
    "data-name": "Path 111802",
    d: "M148.27,35.729a2.58,2.58,0,0,1,2.032,3.066,9.608,9.608,0,0,1-2.032,4.946s1.809-2.975,1.746-5.122a3.254,3.254,0,0,0-1.746-2.89",
    transform: "translate(-2.247 -0.541)",
    fill: "#db9f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111803",
    "data-name": "Path 111803",
    d: "M147.635,19.594c-1.129-6.156-35.142-6.156-36.271,0-1.208,6.592,1.4,20.767,3.1,28.227,1.566,6.877,5.331,8.31,7.771,10.092,3.1,2.264,6.038,3.606,7.267,3.606s4.165-1.341,7.268-3.606c2.44-1.782,6.206-3.215,7.771-10.092,1.7-7.46,4.3-21.635,3.1-28.227",
    transform: "translate(-1.683 -0.227)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111804",
    "data-name": "Path 111804",
    d: "M126.946,60.781a28.137,28.137,0,0,1-4.731-2.838c-2.44-1.781-6.206-3.215-7.771-10.091-1.7-7.461-4.3-21.636-3.1-28.228.161-.876.986-1.627,2.289-2.253a13.671,13.671,0,0,0-1.6,7.345c.254,4.317,2.695,22.09,5.332,26.915,2.412,3.894,9.577,9.15,9.577,9.15",
    transform: "translate(-1.682 -0.263)",
    fill: "#f2ac85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111805",
    "data-name": "Path 111805",
    d: "M133.031,31.1s6.4-1.928,10.981.308a6.942,6.942,0,0,1,2.084,1.84,13.9,13.9,0,0,0-7.182-1.776c-3.492.036-5.509.315-5.883-.372",
    transform: "translate(-2.016 -0.459)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111806",
    "data-name": "Path 111806",
    d: "M125.95,31.037s4.08,5.907,2.234,12.7c0,0,1.55-8.624-4.026-12.485a3.453,3.453,0,0,1,1.792-.214",
    transform: "translate(-1.881 -0.47)",
    fill: "#db9f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111807",
    "data-name": "Path 111807",
    d: "M128.2,43.931s-3.228,3.623-.267,3.623c0,0-2.206-.2.267-3.623",
    transform: "translate(-1.919 -0.666)",
    fill: "#db9f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111808",
    "data-name": "Path 111808",
    d: "M128.634,47.556a.535.535,0,0,0-.173.509c.1.317.807-.423.807-.66,0-.138-.492.011-.633.151",
    transform: "translate(-1.946 -0.717)",
    fill: "#db9f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111809",
    "data-name": "Path 111809",
    d: "M131.466,47.556a.535.535,0,0,1,.173.509c-.1.317-.807-.423-.807-.66,0-.138.492.011.633.151",
    transform: "translate(-1.982 -0.717)",
    fill: "#db9f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111810",
    "data-name": "Path 111810",
    d: "M128.583,43.922c-.441.749-.523,1.616.014,1.893.7.358.995-.589,1.2-1.478.308-1.3-.118-2.058-.336-2.033-.4.046-.358.729-.882,1.618",
    transform: "translate(-1.943 -0.641)",
    fill: "#fdd0b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111811",
    "data-name": "Path 111811",
    d: "M125.777,31.025s-6.4-1.928-10.981.308a6.946,6.946,0,0,0-2.084,1.839,13.9,13.9,0,0,1,7.181-1.775c3.492.035,5.509.314,5.883-.372",
    transform: "translate(-1.708 -0.458)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_80545",
    "data-name": "Group 80545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80544",
    "data-name": "Group 80544",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111812",
    "data-name": "Path 111812",
    d: "M128.831,57.352a1.907,1.907,0,0,0,2.968.032,5.661,5.661,0,0,1-1.484.231,5.737,5.737,0,0,1-1.484-.264",
    transform: "translate(-1.952 -0.869)",
    fill: "#db9f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111813",
    "data-name": "Path 111813",
    d: "M136.671,50.542c-.084.042-.321.338-.4.378a21.486,21.486,0,0,0-2.444,3.561,3.539,3.539,0,0,1-3.57,2.112,4.113,4.113,0,0,1-3.885-2.1,22.8,22.8,0,0,0-2.655-3.745c-.092-.045-.384-.254-.483-.3a9.858,9.858,0,0,0,3.035.161,17.954,17.954,0,0,1,3.747.184A13.309,13.309,0,0,1,135,50.737a5,5,0,0,0,1.67-.195",
    transform: "translate(-1.867 -0.764)",
    fill: "#ff6171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111814",
    "data-name": "Path 111814",
    d: "M125.615,51.482s.594.155,1.912.374a17.353,17.353,0,0,0,2.527.343,18.674,18.674,0,0,0,2.86-.4c1.173-.2,1.78-.349,1.78-.349l-1.17,1.311c-.86,1.131-2.025,1.311-3.578,1.311a3.52,3.52,0,0,1-2.984-1.207Z",
    transform: "translate(-1.903 -0.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111815",
    "data-name": "Path 111815",
    d: "M131.92,55.061c-.1-.262-3.59-.365-3.13.127,1.013,1.084,3.329.382,3.13-.127",
    transform: "translate(-1.951 -0.831)",
    fill: "#ff818d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111816",
    "data-name": "Path 111816",
    d: "M132.483,54.772c-.1-.03-.42.514-.215.526a.288.288,0,0,0,.215-.526",
    transform: "translate(-2.003 -0.83)",
    fill: "#ff818d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111817",
    "data-name": "Path 111817",
    d: "M136.19,16.08A59.9,59.9,0,0,1,120.6,25.409c-8.321,3.1-9.174,5.845-9.174,5.845s-11.6,19.7.068,31.389c0,0-6.5-2.928-9.08-6.428-2.633-3.582-2.45-7.025.724-13.35s1.142-9.283.762-13.707-2.032-19.532,10.791-25.88,24.315-2.032,24.79.888c0,0,11.14,1.555,11.013,12.9s1.127,12.773,2.349,15.95c3.917,10.18,7.11,23.844-8,27.461,0,0,8.158-3.614,8-11.592-.168-8.455-4.82-11.5-5.553-17.893s-11.1-14.916-11.1-14.916",
    transform: "translate(-1.524 0)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111818",
    "data-name": "Path 111818",
    d: "M136.563,14.155s1.368,8.763-17.273,13.876c-10.4,2.852-9.715,9.771-9.715,9.771a13.145,13.145,0,0,1,7.449-13.452Z",
    transform: "translate(-1.659 -0.214)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111819",
    "data-name": "Path 111819",
    d: "M136.977,14.155s-1.808,5.526,4.987,9.915,6.661,13.013,6.378,16.552c0,0,2.393-12.108-3.578-19.955-4.956-6.513-7.787-6.513-7.787-6.513",
    transform: "translate(-2.072 -0.214)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111820",
    "data-name": "Path 111820",
    d: "M134.811,36.66a5.47,5.47,0,0,1,1.312-2.055,7.3,7.3,0,0,1,4.331-1.721,2.473,2.473,0,0,1,2.477,1.742,2.632,2.632,0,0,1-.089,1.452l-8.031.582",
    transform: "translate(-2.043 -0.498)",
    fill: "#8a726b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111821",
    "data-name": "Path 111821",
    d: "M134.163,38.2s1.228-4.62,5.095-4.12a4.632,4.632,0,0,1,3.65,2.149s-1,3.868-4.181,4.05a5.031,5.031,0,0,1-4.564-2.079",
    transform: "translate(-2.033 -0.516)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111822",
    "data-name": "Path 111822",
    d: "M134.163,38.183a4.462,4.462,0,0,1,4.789-2.908c2.608.343,2.972,1.354,2.972,1.354s-.4,3.167-3.39,3.338a5.044,5.044,0,0,1-4.372-1.784",
    transform: "translate(-2.033 -0.534)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111823",
    "data-name": "Path 111823",
    d: "M138.37,34.41s1.774-.653,1.926-1.652a1.861,1.861,0,0,1-1.926,1.652",
    transform: "translate(-2.097 -0.496)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111824",
    "data-name": "Path 111824",
    d: "M139.513,34.522s1.774-.653,1.927-1.652a1.843,1.843,0,0,1-1.927,1.652",
    transform: "translate(-2.114 -0.498)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111825",
    "data-name": "Path 111825",
    d: "M140.326,34.993s1.774-.653,1.927-1.652a2,2,0,0,1-1.927,1.652",
    transform: "translate(-2.126 -0.505)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111826",
    "data-name": "Path 111826",
    d: "M141.212,35.338s1.509-.555,1.64-1.405a1.658,1.658,0,0,1-1.64,1.405",
    transform: "translate(-2.14 -0.514)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111827",
    "data-name": "Path 111827",
    d: "M142.044,35.634s1.173-.431,1.274-1.092a1.3,1.3,0,0,1-1.274,1.092",
    transform: "translate(-2.152 -0.523)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111828",
    "data-name": "Path 111828",
    d: "M142.691,36.238c.309-.191.709-.409.837-.771a1.258,1.258,0,0,1-.7.981Z",
    transform: "translate(-2.162 -0.537)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111829",
    "data-name": "Path 111829",
    d: "M142.75,36.633a1.449,1.449,0,0,1,.524.375,2.108,2.108,0,0,0-.566-.258Z",
    transform: "translate(-2.162 -0.555)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111830",
    "data-name": "Path 111830",
    d: "M142.7,37.007a1.6,1.6,0,0,1,.576.413,2.311,2.311,0,0,0-.622-.284Z",
    transform: "translate(-2.161 -0.561)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111831",
    "data-name": "Path 111831",
    d: "M142.438,37.4a1.6,1.6,0,0,1,.576.413,2.312,2.312,0,0,0-.622-.284Z",
    transform: "translate(-2.157 -0.567)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111832",
    "data-name": "Path 111832",
    d: "M135.391,37.389A2.387,2.387,0,1,0,137.778,35a2.387,2.387,0,0,0-2.387,2.387",
    transform: "translate(-2.051 -0.53)",
    fill: "#3e2b1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111833",
    "data-name": "Path 111833",
    d: "M137.2,38.628a1.808,1.808,0,0,0,.247-3.6A2.281,2.281,0,0,1,137.7,35a2.436,2.436,0,1,1-2.282,2.059,1.806,1.806,0,0,0,1.788,1.566",
    transform: "translate(-2.051 -0.53)",
    fill: "#815233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111834",
    "data-name": "Path 111834",
    d: "M139.146,36.944a1.813,1.813,0,0,1-1.813,1.813,2.06,2.06,0,0,1-1.917-1.694,2.293,2.293,0,0,1,2.036-2.036,2.058,2.058,0,0,1,1.694,1.917",
    transform: "translate(-2.052 -0.531)",
    fill: "#3e2b1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111835",
    "data-name": "Path 111835",
    d: "M136.413,38.484a.32.32,0,1,0,.319-.32.32.32,0,0,0-.319.32",
    transform: "translate(-2.067 -0.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111836",
    "data-name": "Path 111836",
    d: "M135.479,36.288a4.02,4.02,0,0,1,3.668-1,2.851,2.851,0,0,0-2.469-.343c-1.143.539-1.2,1.338-1.2,1.338",
    transform: "translate(-2.053 -0.527)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111837",
    "data-name": "Path 111837",
    d: "M124.151,36.817a5.47,5.47,0,0,0-1.312-2.055,7.311,7.311,0,0,0-4.331-1.721,2.474,2.474,0,0,0-2.477,1.742,2.637,2.637,0,0,0,.089,1.453l8.031.581",
    transform: "translate(-1.757 -0.501)",
    fill: "#8a726b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111838",
    "data-name": "Path 111838",
    d: "M124.711,38.126s-1.228-4.62-5.1-4.12a4.631,4.631,0,0,0-3.649,2.149s1,3.868,4.181,4.05a5.031,5.031,0,0,0,4.564-2.079",
    transform: "translate(-1.757 -0.515)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111839",
    "data-name": "Path 111839",
    d: "M124.727,38.113a4.46,4.46,0,0,0-4.789-2.907c-2.608.342-2.972,1.353-2.972,1.353s.4,3.167,3.389,3.338a5.045,5.045,0,0,0,4.373-1.784",
    transform: "translate(-1.772 -0.533)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111840",
    "data-name": "Path 111840",
    d: "M120.61,34.341s-1.774-.653-1.927-1.652a1.861,1.861,0,0,0,1.927,1.652",
    transform: "translate(-1.798 -0.495)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111841",
    "data-name": "Path 111841",
    d: "M119.467,34.452s-1.774-.653-1.927-1.652a1.843,1.843,0,0,0,1.927,1.652",
    transform: "translate(-1.781 -0.497)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111842",
    "data-name": "Path 111842",
    d: "M118.654,34.923s-1.774-.653-1.927-1.651a2,2,0,0,0,1.927,1.651",
    transform: "translate(-1.769 -0.504)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111843",
    "data-name": "Path 111843",
    d: "M117.772,35.269s-1.509-.555-1.64-1.405a1.658,1.658,0,0,0,1.64,1.405",
    transform: "translate(-1.76 -0.513)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111844",
    "data-name": "Path 111844",
    d: "M116.945,35.564s-1.173-.432-1.274-1.092a1.3,1.3,0,0,0,1.274,1.092",
    transform: "translate(-1.753 -0.522)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111845",
    "data-name": "Path 111845",
    d: "M116.305,36.168c-.308-.191-.709-.409-.837-.771a1.258,1.258,0,0,0,.7.981Z",
    transform: "translate(-1.75 -0.536)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111846",
    "data-name": "Path 111846",
    d: "M116.251,36.563a1.457,1.457,0,0,0-.524.375,2.108,2.108,0,0,1,.566-.258Z",
    transform: "translate(-1.753 -0.554)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111847",
    "data-name": "Path 111847",
    d: "M116.3,36.937a1.6,1.6,0,0,0-.576.413,2.311,2.311,0,0,1,.622-.284Z",
    transform: "translate(-1.753 -0.56)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111848",
    "data-name": "Path 111848",
    d: "M116.561,37.329a1.6,1.6,0,0,0-.576.413,2.311,2.311,0,0,1,.622-.284Z",
    transform: "translate(-1.757 -0.566)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111849",
    "data-name": "Path 111849",
    d: "M123.545,37.319a2.387,2.387,0,1,1-2.387-2.387,2.387,2.387,0,0,1,2.387,2.387",
    transform: "translate(-1.8 -0.529)",
    fill: "#3e2b1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111850",
    "data-name": "Path 111850",
    d: "M121.734,38.558a1.808,1.808,0,0,1-.247-3.6,2.28,2.28,0,0,0-.247-.025,2.307,2.307,0,1,0,2.308,2.307,2.284,2.284,0,0,0-.025-.247,1.808,1.808,0,0,1-1.789,1.566",
    transform: "translate(-1.802 -0.529)",
    fill: "#815233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111851",
    "data-name": "Path 111851",
    d: "M119.806,36.874a1.813,1.813,0,0,0,1.813,1.813,2.06,2.06,0,0,0,1.917-1.694,2.293,2.293,0,0,0-2.036-2.036,2.058,2.058,0,0,0-1.694,1.917",
    transform: "translate(-1.815 -0.53)",
    fill: "#3e2b1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111852",
    "data-name": "Path 111852",
    d: "M121.012,38.305a.32.32,0,1,1-.32-.319.32.32,0,0,1,.32.319",
    transform: "translate(-1.824 -0.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111853",
    "data-name": "Path 111853",
    d: "M123.475,36.218a4.021,4.021,0,0,0-3.668-1,2.849,2.849,0,0,1,2.468-.343c1.144.539,1.2,1.338,1.2,1.338",
    transform: "translate(-1.815 -0.526)",
    fill: "#1f1610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111854",
    "data-name": "Path 111854",
    d: "M84.718,126.747c.614-2.638,2.4-17.612,3.516-22.37,1.723-7.316,2.02-12.963,5.06-23.358,2.372-8.109,12.566-8.248,12.566-8.248,3.8,5.627,1.95,21.5-.3,31.578-1.9,8.491-5.485,17.349-6.828,24.275-.932,4.8-5.888,11.535-10.84,9.261-4.55-2.087-4.813-4.069-3.17-11.139",
    transform: "translate(-1.27 -1.103)",
    fill: "#3e454f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111855",
    "data-name": "Path 111855",
    d: "M172.066,166.5a10.952,10.952,0,0,1-3.022,4.681c-2.157,1.8-5.32,1.014-7.693.224-1.655-.5-4.731-5.236-8.542-7.16s1.725-2.857,4.171-2.21,4.386,1.53,5.752,1.879a12.853,12.853,0,0,1,2.876,1.428c.791.359,2.588-2.085,2.588-2.085Z",
    transform: "translate(-2.296 -2.452)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111856",
    "data-name": "Path 111856",
    d: "M151.921,163.711a4.58,4.58,0,0,0,.9.564c3.81,1.922,6.887,6.656,8.542,7.159,1.713.571,3.862,1.276,5.723.728,0,0-1.531-.6-3.542-1.349-2.321-.866-2.383-2.1-2.977-3.944-1.224-3.794-8.642-3.157-8.642-3.157",
    transform: "translate(-2.302 -2.48)",
    fill: "#e6a987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111857",
    "data-name": "Path 111857",
    d: "M183.159,114.908a63.471,63.471,0,0,1-3.722-7.085c-3.04-6.728-11.1-21.369-14.318-29.019s-13.7-5.551-13.7-5.551c-2.233,6.282,3.232,20.972,7.844,30.005,3.887,7.611,9.468,15.159,12.443,21.417,2.062,4.336,9.761,10.7,12.581,6.153s1.827-10.627-1.128-15.921",
    transform: "translate(-2.286 -1.106)",
    fill: "#3e454f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111858",
    "data-name": "Path 111858",
    d: "M150.6,230.549s-2.579,18.433-3.159,21.789-11.269,8.349-14.4,2.885c.027-2.935-1.559-12.068-2.039-18.875s-3.18-23.2-2.069-23.771,23.253-.256,23.253-.256Z",
    transform: "translate(-1.949 -3.216)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111859",
    "data-name": "Path 111859",
    d: "M132.865,259.917s1.727,17.09,2.767,37.3c.7,13.665,1.091,28.757.419,40.959,0,0-.245,11.8-.983,23.356.245,3.442,9.342,1.475,10.817,1.229s-2.458-24.339-2.458-24.339a28.2,28.2,0,0,0-.436-7.083c-.738-4.179-1.3-3.672.844-13.923,2.247-10.733,6.87-36.469,6.671-43.48-.223-7.816-1.916-22.747-6.671-27.921,0,0-1.43-.5-6.54.271s-4.43,13.629-4.43,13.629",
    transform: "translate(-2.013 -3.725)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111860",
    "data-name": "Path 111860",
    d: "M136.009,340.805s-4.023,21.87-4.167,26.049c-.107,3.077.458,3.082,7.577,3.065,8.386-.021,10.841.548,9.071-5.578-2.017-6.984-5.078-24.494-5.078-24.494s2.881,20.18,2.336,23.268c-.317,1.793-9.572,1.276-9.81,0-.551-2.952.07-22.31.07-22.31",
    transform: "translate(-1.997 -5.149)",
    fill: "#272424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111861",
    "data-name": "Path 111861",
    d: "M136.617,255.7s5.136,3.616,7.856,1.915c0,0-6.128-.79-7.856-1.915",
    transform: "translate(-2.07 -3.874)",
    fill: "#e6a987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111862",
    "data-name": "Path 111862",
    d: "M111.272,230.549s2.579,18.433,3.159,21.789,11.269,8.349,14.4,2.885c-.027-2.935,1.559-12.068,2.039-18.875s3.18-23.2,2.069-23.771-23.253-.256-23.253-.256Z",
    transform: "translate(-1.662 -3.216)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111863",
    "data-name": "Path 111863",
    d: "M129.1,259.917s-1.727,17.09-2.767,37.3c-.7,13.665-1.092,28.757-.42,40.959,0,0,.244,11.8.983,23.356-.246,3.442-9.342,1.475-10.817,1.229s2.458-24.339,2.458-24.339a28.2,28.2,0,0,1,.436-7.083c.738-4.179,1.3-3.672-.844-13.923-2.247-10.733-6.87-36.469-6.671-43.48.223-7.816,1.917-22.747,6.671-27.921,0,0,1.43-.5,6.54.271s4.43,13.629,4.43,13.629",
    transform: "translate(-1.689 -3.725)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111864",
    "data-name": "Path 111864",
    d: "M120.917,257.987s6.277.229,7.63-2.681c0,0-5.567,2.681-7.63,2.681",
    transform: "translate(-1.832 -3.868)",
    fill: "#e6a987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111865",
    "data-name": "Path 111865",
    d: "M125.962,340.805s4.023,21.87,4.167,26.049c.107,3.077-.458,3.082-7.578,3.065-8.385-.021-10.841.548-9.07-5.578,2.017-6.984,5.078-24.494,5.078-24.494s-2.881,20.18-2.336,23.268c.317,1.793,9.572,1.276,9.81,0,.551-2.952-.07-22.31-.07-22.31",
    transform: "translate(-1.711 -5.149)",
    fill: "#272424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111866",
    "data-name": "Path 111866",
    d: "M156.718,172.067c-5.716-20.781-10.971-29.1-10.971-29.1l-15.882,1.83-16.784-2.059s-3.234,8.674-8.949,29.455c-3.061,15.347,2.017,40.454,3.375,54.368.349,3.574,1.214,16.505,1.214,16.505s11.4,4.86,21.222,4.86c13.164-.709,20.893-4.354,20.893-4.354s2.518-13.033,2.867-16.607c1.365-13.983,6.1-39.43,3.016-54.9",
    transform: "translate(-1.563 -2.163)",
    fill: "#2f343b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111867",
    "data-name": "Path 111867",
    d: "M117.275,143.233l-4.193-.484s-3.234,8.674-8.949,29.455c-3.061,15.347,2.017,40.455,3.375,54.368.349,3.574,1.213,16.505,1.213,16.505s2.094.721,4.357,1.607c0,0-3.212-9.628-3.51-15.73s-3.308-36.669-3.01-47.411,10.717-38.311,10.717-38.311",
    transform: "translate(-1.563 -2.163)",
    fill: "#23272c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111868",
    "data-name": "Path 111868",
    d: "M152.8,86.2c.606-6.687,1.827-12.951,1.827-12.951l-14.787-1.77c0,.036-8.941,8.208-9.618,8.208-.972,0-9.955-6.839-10.515-8.208L106.7,73.266s.775,6.246,1.38,12.933c.42,5.088.724,7.025.261,11.426-.917,8.732-3.323,7.2.7,18.835.412,1.194.784,20.4.935,32.393,0,0,6.522,4.286,17.571,4.286h5.8c11.049,0,17.57-4.286,17.57-4.286.01-10.546.523-31.2.936-32.393,4.017-11.638,1.611-10.1.694-18.835-.462-4.4-.158-6.338.261-11.426",
    transform: "translate(-1.617 -1.083)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111869",
    "data-name": "Path 111869",
    d: "M151.681,118.376c.027-.38.053-.7.08-.953,2.374-6.294,2.9-9.831,1.924-13.039-.979-3.226-1.408-10.411-1.408-10.411s-.17,7.748.45,11.157-.156,4.8-6.974,6.509a72.4,72.4,0,0,1-15.469,1.606v0a70.319,70.319,0,0,1-15.192-1.59c-6.818-1.7-7.593-3.1-6.973-6.509s.449-11.157.449-11.157-.428,7.185-1.407,10.411-.446,6.782,1.961,13.14l.3,4.942c.253,6.874.46,18.488.563,26.71,0,0,6.522,4.287,17.571,4.287h5.8c11.048,0,17.57-4.287,17.57-4.287.007-7.226.25-19.2.535-26.4Z",
    transform: "translate(-1.617 -1.424)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111870",
    "data-name": "Path 111870",
    d: "M139.012,71s.676.364,0,1.378-8.432,7.3-8.432,7.3,6.363-1.555,7.17-.039c.96,1.8,1.989,4.416,1.989,4.416s2.111-11.7.677-13.055c-.545-.515-1.4,0-1.4,0",
    transform: "translate(-1.978 -1.072)",
    fill: "#f3f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111871",
    "data-name": "Path 111871",
    d: "M121.153,71.172s-.676.364,0,1.378,9.256,7.128,9.256,7.128-7.186-1.383-7.993.133c-.96,1.8-1.989,4.416-1.989,4.416s-2.112-11.7-.677-13.055c.545-.515,1.4,0,1.4,0",
    transform: "translate(-1.807 -1.075)",
    fill: "#f3f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111872",
    "data-name": "Path 111872",
    d: "M131.589,87.284a.941.941,0,1,1-.941-.942.941.941,0,0,1,.941.942",
    transform: "translate(-1.965 -1.308)",
    fill: "#f3f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111873",
    "data-name": "Path 111873",
    d: "M131.589,98.987a.941.941,0,1,1-.941-.942.941.941,0,0,1,.941.942",
    transform: "translate(-1.965 -1.486)",
    fill: "#f3f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111874",
    "data-name": "Path 111874",
    d: "M131.589,110.689a.941.941,0,1,1-.941-.941.941.941,0,0,1,.941.941",
    transform: "translate(-1.965 -1.663)",
    fill: "#f3f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111875",
    "data-name": "Path 111875",
    d: "M131.589,122.392a.941.941,0,1,1-.941-.942.941.941,0,0,1,.941.942",
    transform: "translate(-1.965 -1.84)",
    fill: "#f3f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111876",
    "data-name": "Path 111876",
    d: "M131.589,134.095a.941.941,0,1,1-.941-.942.941.941,0,0,1,.941.942",
    transform: "translate(-1.965 -2.017)",
    fill: "#f3f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111877",
    "data-name": "Path 111877",
    d: "M131.589,145.8a.941.941,0,1,1-.941-.941.942.942,0,0,1,.941.941",
    transform: "translate(-1.965 -2.195)",
    fill: "#f3f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111878",
    "data-name": "Path 111878",
    d: "M141.137,71.118s8.022.831,12.568,1.5a12.371,12.371,0,0,1,2.717.631c.423,1.649-1.881,30.419-1.265,34.806.412,2.632-2.838,13.307-2.705,20.326s8.587,38.927,9.323,43.291-20.029,6.418-29.085,6.415c0,0,1.4-40.378,1.606-52.485.149-8.786,5.433-22.5,5.941-28.544s.9-25.937.9-25.937",
    transform: "translate(-2.01 -1.078)",
    fill: "#3e454f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111879",
    "data-name": "Path 111879",
    d: "M159.809,174.366c1.648-.712,2.282-1.589,2.135-2.462-.736-4.364-9.19-36.272-9.323-43.291s3.117-17.695,2.705-20.326c-.4-2.865.217-14.285.443-22.542,0,0-2.307,19.1-2.6,24.507-.124,2.288-9.364,3.015-9.364,3.015s8.7-.208,9.071,1.614c.344,1.678-1.52,10.4-1.721,13.5s8.652,45.988,8.652,45.988",
    transform: "translate(-2.179 -1.299)",
    fill: "#2f343b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111880",
    "data-name": "Path 111880",
    d: "M138.9,151.489a100.947,100.947,0,0,0,14.615-1.455l.2,1.245s-4.858,1.734-14.568,1.746Z",
    transform: "translate(-2.105 -2.273)",
    fill: "#2f343b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111881",
    "data-name": "Path 111881",
    d: "M135.281,117.971s7.023-7.533,10.009-12.136l-2.907-1.623,6.815-3.47s-5.643-28.695-6.52-29.59-1.456-.792-1.456-.792-1.051,18.366-1.778,26.572-3.375,15.133-4.164,21.038",
    transform: "translate(-2.05 -1.066)",
    fill: "#48505c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111882",
    "data-name": "Path 111882",
    d: "M118.786,71.118s-8.022.831-12.567,1.5l-2.572.416c.612,1.589.852,30.635.234,35.021-.412,2.632,3.723,13.307,3.59,20.326s-7.7,38.927-8.437,43.291,19.143,6.418,28.2,6.415c0,0-1.4-40.378-1.606-52.485-.149-8.786-5.433-22.5-5.941-28.544s-.9-25.937-.9-25.937",
    transform: "translate(-1.5 -1.078)",
    fill: "#3e454f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111883",
    "data-name": "Path 111883",
    d: "M100.845,174.251c-1.279-.654-1.959-1.472-1.811-2.347.736-4.364,8.305-36.271,8.438-43.29s-4-17.695-3.591-20.326a209.632,209.632,0,0,0,.6-22.407s1.267,18.966,1.56,24.372c.123,2.287,10.247,3.015,10.247,3.015s-9.582-.208-9.955,1.614c-.345,1.678,2.4,10.4,2.6,13.5s-8.091,45.871-8.091,45.871",
    transform: "translate(-1.5 -1.301)",
    fill: "#2f343b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111884",
    "data-name": "Path 111884",
    d: "M121.225,151.489a100.946,100.946,0,0,1-14.615-1.455l-.2,1.245s4.858,1.734,14.568,1.746Z",
    transform: "translate(-1.612 -2.273)",
    fill: "#2f343b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111885",
    "data-name": "Path 111885",
    d: "M125.043,119.069s-7.2-8.631-10.189-13.234l2.907-1.623-6.815-3.47s5.643-28.694,6.519-29.59,1.457-.791,1.457-.791,1.051,18.365,1.778,26.571,3.555,16.231,4.344,22.136",
    transform: "translate(-1.681 -1.066)",
    fill: "#48505c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111886",
    "data-name": "Path 111886",
    d: "M160.785,162.828s-3.914-3.473-5.38-4.4-5.029-1.538-6.758-2.256-1.414,1.281,0,2.355,4.3,1.366,4.61,1.561,2.986,3.221,3.981,4.269,4.542-.042,3.547-1.529",
    transform: "translate(-2.234 -2.364)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111887",
    "data-name": "Path 111887",
    d: "M155.541,162.523l2.157-.348-2.46-.039Z",
    transform: "translate(-2.352 -2.457)",
    fill: "#e6b296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111888",
    "data-name": "Path 111888",
    d: "M165.623,167.853a50.937,50.937,0,0,0-5.521-5.49c-1.1-.7-3.977.138-5.737.311-1.189.143-3.43,4.514-4.676,6.042s1.066,1.668,1.912.958,3.4-4.3,3.868-4.591,3.667.684,4.023.733,6.132,2.037,6.132,2.037",
    transform: "translate(-2.263 -2.456)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111889",
    "data-name": "Path 111889",
    d: "M151.05,170s2.59-4.922,4.047-6.058a22.592,22.592,0,0,1,5.361-.558,2.561,2.561,0,0,1,1.334.572c.158.154-3.787-1.3-10.742,6.044",
    transform: "translate(-2.289 -2.475)",
    fill: "#e6b296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111890",
    "data-name": "Path 111890",
    d: "M166.892,169.237s-3.588-4.369-5.334-5.567c-1.1-.7-4.164.216-5.926.389-1.187.143-3.428,4.514-4.674,6.042s1.066,1.668,1.912.959,3.4-4.3,3.868-4.592,3.667.684,4.023.733,6.132,2.037,6.132,2.037",
    transform: "translate(-2.282 -2.476)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111891",
    "data-name": "Path 111891",
    d: "M157.857,166.526s.327-.569.736-.622a24.109,24.109,0,0,1,4.178-.183l.434.277-5.133.564Z",
    transform: "translate(-2.392 -2.51)",
    fill: "#e6b296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111892",
    "data-name": "Path 111892",
    d: "M168.848,171.457a47.5,47.5,0,0,0-4.876-5.4c-.991-.712-3.718-.074-5.37,0-1.116.073-3.429,4.04-4.669,5.4s.909,1.611,1.735.992,3.388-3.843,3.843-4.09,3.388.823,3.718.886,5.62,2.212,5.62,2.212",
    transform: "translate(-2.327 -2.511)",
    fill: "#fdc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111893",
    "data-name": "Path 111893",
    d: "M163.341,162.386a22.2,22.2,0,0,0,9.668,5.264s4.958-11.321,6.941-17.27,4.552-13.233,5.612-20.949c1.825-13.283-10.768-15.332-13.669-1.383-1.206,6.52-2.773,12.842-4.338,18.861-1.457,5.6-4.214,15.477-4.214,15.477",
    transform: "translate(-2.475 -1.795)",
    fill: "#3e454f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111894",
    "data-name": "Path 111894",
    d: "M172.109,127.691l.367-1.4-1.139-2.217s-.1-1.077.569-.116,1.991,1.7,4.74,1.434c2.5-.593.121.269-1.409.621-1.668.386-2.139.738-2.386,1.761a15.2,15.2,0,0,1-1.318,2.85Z",
    transform: "translate(-2.596 -1.872)",
    fill: "#2f343b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111895",
    "data-name": "Path 111895",
    d: "M43.907,120.864s1.262-8.966,5.043-11.8c0,0,15.8,6.122,21.786,8.347,6.731,2.5,11.785,4.319,18.978,7.652,6.414,2.972,4.913,6.322,3.846,10.012-.911,3.148-3.031,5.242-9.561,2.743-6.251-2.551-16.128-7.084-22.145-9.053-5.6-1.832-17.947-7.9-17.947-7.9",
    transform: "translate(-0.665 -1.653)",
    fill: "#3e454f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111896",
    "data-name": "Path 111896",
    d: "M46.459,111.774a9.224,9.224,0,0,1,2.491-3.247s15.8,6.123,21.786,8.347c5.108,1.9,9.253,3.406,14.1,5.477.812-5.589,1.981-14.491,2.8-17.962,1.723-7.316,2.02-12.963,5.06-23.358,1.765-6.033,7.859-7.654,10.864-8.09,0,0-6.436,1.626-9.063,10.408a175.615,175.615,0,0,0-5.581,24.866c-.656,5.581-3.352,12.708-1.477,15.922,1.149,1.97,4.294,5.6-.207,1.376-1.56-1.464-6.113-3.085-10.134-4.987-3-1.417-9.522-2.768-11.656-3.753S58.051,112.8,54.6,112.232a53.231,53.231,0,0,0-8.145-.458",
    transform: "translate(-0.704 -1.105)",
    fill: "#2f343b"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_112015",
    "data-name": "Path 112015",
    d: "M60,0A60,60,0,1,1,0,60,60,60,0,0,1,60,0Z",
    transform: "translate(2611.434 479.434)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionals);
export default __webpack_public_path__ + "static/media/professionals.071af1e8632e2bab56fb82a9f52fff08.svg";
export { ForwardRef as ReactComponent };